// extracted by mini-css-extract-plugin
export var statItem = "_fj-1";
export var statsRow = "_fj-0";